import useAuthStore from '@/stores/useAuthStore'
import { useMemo } from 'react'
import DraggableLayout, { WidgetConfig } from '../shared/DraggableLayout'

// Import shared components
import Business from '@/modules/Dashboard/components/shared/Business'
import WorkDays from '@/modules/Dashboard/components/shared/WorkDays'
import MyWorkdays from '../../shared/MyWorkdays'
import Notifications from '../../shared/Notifications'
import Paper from '@/components/Paper'
import QuoteOfTheDay from '../../shared/QuoteOfTheDay'
import TargetRevenue from '../../shared/TargetRevenue'

// Import Technical specific widgets
import TechnicalTicketsWidget from './widgets/TechnicalTicketsWidget'
import OncallTimelineWidget from './widgets/OncallTimelineWidget'
import SLADashboardWidget from './widgets/SLADashboardWidget'
import InternalInformation from '../../shared/InternalInformation'
import Events from '../../shared/Events'

const TechDashboard = () => {
    const employee = useAuthStore((state) => state.employee)

    // Storage key unique per employee
    const storageKey = useMemo(
        () => `dashboard_layout_tech_${employee?.employee_id || 'default'}`,
        [employee?.employee_id]
    )

    // Widget configurations with colSpan (3, 4, 6, 8, or 12)
    const widgets: WidgetConfig[] = useMemo(
        () => [
            {
                id: 'quote_of_the_day',
                component: (
                    <Paper className="h-full">
                        <QuoteOfTheDay />
                    </Paper>
                ),
                colSpan: 12,
            },
            {
                id: 'tickets',
                component: <TechnicalTicketsWidget />,
                colSpan: 3,
            },
            {
                id: 'sla-dashboard',
                component: <SLADashboardWidget />,
                colSpan: 3,
            },
            {
                id: 'my_workdays',
                component: (
                    <Paper className="h-full">
                        <MyWorkdays />
                    </Paper>
                ),
                colSpan: 3,
            },
            {
                id: 'oncall-timeline',
                component: (
                    <Paper className="h-full">
                        <OncallTimelineWidget />
                    </Paper>
                ),
                colSpan: 6,
            },
            {
                id: 'notification',
                component: (
                    <Paper className="h-full">
                        <Notifications />
                    </Paper>
                ),
                colSpan: 6,
            },
            {
                id: 'events',
                component: (
                    <Paper className="h-full">
                        <Events />
                    </Paper>
                ),
                colSpan: 3,
            },
            {
                id: 'internal-information',
                component: (
                    <Paper className="h-full">
                        <InternalInformation />
                    </Paper>
                ),
                colSpan: 6,
            },
            {
                id: 'business',
                component: (
                    <Paper className="h-full">
                        <Business
                            showCreateButton
                            defaultBusinessType="datacenter"
                        />
                    </Paper>
                ),
                colSpan: 3,
            },
            {
                id: 'workday',
                component: (
                    <Paper className="h-full">
                        <WorkDays />
                    </Paper>
                ),
                colSpan: 3,
            },
            {
                id: 'revenue',
                component: (
                    <Paper className="h-full">
                        <TargetRevenue />
                    </Paper>
                ),
                colSpan: 6,
            },
        ],
        []
    )

    return (
        <DraggableLayout
            widgets={widgets}
            storageKey={storageKey}
            department="TECHNOLOGY"
        />
    )
}

export default TechDashboard
